import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { useLogoutMutation } from '@/hooks/use-auth';
import { MENU_LABELS, type MenuKey } from '@ope-v3/shared';

export function TopNav(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const logout = useLogoutMutation();

  if (!user) return null;
  if (location.pathname === '/login') return null;

  const isHome = location.pathname === '/';
  const pageKey = location.pathname.split('/')[1] as MenuKey | undefined;
  const pageLabel = pageKey && pageKey in MENU_LABELS ? MENU_LABELS[pageKey] : '';

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-30 no-print">
      <div className="max-w-screen-2xl mx-auto px-3 sm:px-5 py-2.5 flex items-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 text-gray-700 hover:text-blue-600 shrink-0"
        >
          <span className="text-xl">📋</span>
          <span className="font-semibold text-sm hidden sm:inline">STH</span>
        </Link>
        {!isHome && pageLabel && (
          <>
            <span className="text-gray-300">/</span>
            <span className="text-sm text-gray-600 truncate">{pageLabel}</span>
          </>
        )}
        <div className="flex-1" />
        <div className="flex items-center gap-2 sm:gap-3">
          <span className="text-xs text-gray-500 hidden sm:inline">
            {user.username}
            {user.isAdmin && (
              <span className="ml-1 px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded text-[10px] font-medium">
                ADMIN
              </span>
            )}
          </span>
          <button
            type="button"
            onClick={() => logout.mutate()}
            className="text-xs text-gray-500 hover:text-red-600 px-2 py-1 hover:bg-red-50 rounded"
            disabled={logout.isPending}
          >
            ออกจากระบบ
          </button>
        </div>
      </div>
    </nav>
  );
}
